import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../../../../store/StoreManager';
import properties from '../../../../../constants/Properties';
import platformDetection from '../../../../utils/PlatformDetection';
import mouseUtils from '../../../../utils/MouseUtils';
import { ScrollableComponent } from '../../../ScrollableComponent';
import { expandFontSizeList, expandFontsList } from '../../../../../actions/MenuActions';
import hoverManager from '../../../../utils/HoverManager';
import textEditorUtils from '../../utils/TextEditorUtils';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeTextProperties();
    },
    onButtonClick() {
        let downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeTextProperties();
    },
    changeTextProperties() {
        if (this.props.executeCommand) {
            storeManager.getStore().dispatch(expandFontSizeList(false));

            textEditorUtils.executeAction(15, this.props.value);
            this.props.executeCommand(15, this.props.value, true);
            this.props.refreshView();

            setTimeout(function() {
                let fontSizeButton = document.getElementById('fontSizeMiddle');

                if (fontSizeButton)
                    fontSizeButton.focus();
            }.bind(this), 10);
        }
    },
    render() {
        let iconColor;
        let buttonColor;

        if (this.state.isOver === true) {
            iconColor = properties.CONTEXT_HOVER_COLOR;
            buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
        } else {
            iconColor = 'black';
            buttonColor = properties.SLIDE_MENU_COLOR;
        }

        let topPosition = this.props.index * this.props.height;

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.width,
            height: this.props.height,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 15,
            top: topPosition,
            color: 'white',
            borderStyle: 'none'
        };

        let spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 17,
            fontFamily: this.props.value,
            top: 0
        };

        let iconVisible;

        if (this.props.index === this.props.selectedIndex)
            iconVisible = 'block';
        else
            iconVisible = 'none';

        const iconStyle = {
            position: 'absolute',
            top: 4,
            right: 37,
            color: iconColor,
            display: iconVisible
        };

        if (platformDetection.isIOS() === true) {
            spanStyle.fontSize = 18;
        }

        return (
            <button ref="sizeButton" aria-label={this.props.value} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onButtonClick} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                <span style={spanStyle}>{this.props.value}</span>
                <i style={iconStyle} className='fa fa-check'></i>
            </button>
        );
    }
});

const FontSizeViewContent = React.createClass({
    getInitialState() {
        return {
            isOverLeft: false,
            isOverRight: false,
            isOverCenter: false
        };
    },
    onMouseInLeft() {
        this.setState({
            isOverLeft: true
        });
    },
    onMouseOutLeft() {
        this.setState({
            isOverLeft: false
        });
    },
    onMouseInRight() {
        this.setState({
            isOverRight: true
        });
    },
    onMouseOutRight() {
        this.setState({
            isOverRight: false
        });
    },
    onMouseInCenter() {
        this.setState({
            isOverCenter: true
        });
    },
    onMouseOutCenter() {
        this.setState({
            isOverCenter: false
        });
    },
    onLeftClick() {
        var currentFontSize = textEditorUtils.getCommandValue('fontsize') - 1;

        if (currentFontSize < 5)
            currentFontSize = 5;

        textEditorUtils.executeAction(15, currentFontSize);

        this.props.executeCommand(15);
        this.refreshView(1);
        this.updateButtonFocus(this.refs.leftButton);
    },
    onRightClick() {
        var currentFontSize = textEditorUtils.getCommandValue('fontsize') + 1;

        textEditorUtils.executeAction(15, currentFontSize);

        this.props.executeCommand(16);
        this.refreshView(2);
        this.updateButtonFocus(this.refs.rightButton);
    },
    refreshView(value = 0) {
        setTimeout(function() {
            this.forceUpdate();
        }.bind(this), 10);
    },
    onExpand(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const isExpanded = !this.props.fontSizeListIsExpanded;
        this.props.dispatch(expandFontSizeList(isExpanded));
        this.updateButtonFocus(this.refs.fontSizeInput);
    },
    updateButtonFocus(button) {
        setTimeout(function() {
            button.focus();
        }.bind(this), 100);
    },
    onFocusHandler() {
        if (document.activeElement === this.refs.leftButton) {
            storeManager.getStore().dispatch(expandFontsList(false));
            storeManager.getStore().dispatch(expandFontSizeList(false));
        }
    },
    render() {
        const dataProvider = [12, 14, 18, 24, 30, 36, 48, 60, 72, 96];
        const currentFontSize = textEditorUtils.getCommandValue('fontsize');
        let height = this.props.buttonSize;
        let borderWidth = 2;
        let menuWidth = 3 * this.props.buttonSize;
        let visibleItems = 10;
        let buttonHeight = 25;
        let holderHeight = this.props.buttonSize - 2 * borderWidth;

        if (this.props.fontSizeListIsExpanded === true)
            height = height + visibleItems * buttonHeight + 4;

        const menuStyle = {
            position: 'absolute',
            top: this.props.top,
            left: this.props.left,
            width: menuWidth,
            height: height,
            zIndex: 1100
        };

        /********* left element *************/

        let leftStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: this.props.buttonSize - 2 * borderWidth,
            height: holderHeight,
            background: '#f9f9f9',
            borderTopLeftRadius: 5,
            borderBottomLeftRadius: 5,
            borderWidth: borderWidth,
            borderStyle: 'solid',
            borderColor: '#e7e7e7',
            cursor: 'pointer',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            zIndex: 20
        };

        const minusStyle = {
            position: 'absolute',
            top: -14,
            left: 7,
            height: 20,
            fontSize: 45,
            color: '#5f5f5f'
        };

        if (this.state.isOverLeft)
            leftStyle.backgroundColor = '#edefff';

        /********* center element *************/

        let middleStyle = {
            position: 'absolute',
            top: 0,
            left: 32,
            width: this.props.buttonSize,
            height: holderHeight,
            background: '#ffffff',
            borderWidth: borderWidth,
            borderColor: '#e7e7e7',
            borderTopStyle: 'solid',
            borderBottomStyle: 'solid',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            cursor: 'pointer'
        };

        let fontSizeStyle = {
            position: 'absolute',
            width: middleStyle.width,
            top: 0,
            left: 0,
            height: middleStyle.height - borderWidth,
            color: 'black',
            fontSize: 15,
            fontWeight: 'bold',
            resize: 'none',
            overflow: 'hidden',
            background: 'transparent',
            border: 'none',
            textAlign: 'center',
            paddingLeft: 0,
            paddingRight: 0,
            cursor: 'pointer'
        };

        if (this.state.isOverCenter)
            fontSizeStyle.fontSize = 17;

        let fontSizeInputAriaLabel = currentFontSize;

        if (this.refs.fontSizeInput)
            fontSizeInputAriaLabel = this.refs.fontSizeInput.value;

        /********* right element *************/

        let rightStyle = {
            position: 'absolute',
            top: 0,
            left: 64,
            width: this.props.buttonSize - 2 * borderWidth,
            height: holderHeight,
            background: '#f9f9f9',
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
            borderWidth: borderWidth,
            borderColor: '#e7e7e7',
            borderStyle: 'solid',
            fontSize: 25,
            cursor: 'pointer',
            margin: 0,
            padding: 0,
            boxSizing: 'initial'
        };

        const plusStyle = {
            position: 'absolute',
            top: -7,
            left: 3,
            height: 20,
            fontSize: 40,
            color: '#5f5f5f'
        };

        if (this.state.isOverRight)
            rightStyle.backgroundColor = '#edefff';

        /********* expanded *************/

        let elements = [];
        let listDisplay;

        if (this.props.fontSizeListIsExpanded === true) {
            let i;
            let selectedIndex = -1;

            for (i=0; i<dataProvider.length; i++) {
                if (currentFontSize === dataProvider[i])
                    selectedIndex = i;

                elements.push(<Button executeCommand={this.props.executeCommand} refreshView={this.refreshView} height={buttonHeight} width={menuWidth} index={i} dispatch={this.props.dispatch} shapeModel={this.props.contextTarget} key={'font' + dataProvider[i]} value={dataProvider[i]} selectedIndex={selectedIndex}/>);
            }

            listDisplay = 'block';
        } else {
            listDisplay = 'none';
        }

        const fontSizeListStyle = {
            position: 'absolute',
            width: menuWidth,
            height: buttonHeight * visibleItems,
            top: holderHeight + 2,
            left: 0,
            borderColor: properties.EFFECTS_BUTTON_BORDER_COLOR,
            borderWidth: 1,
            borderStyle: 'solid',
            display: listDisplay,
            overflowY: 'hidden',
            overflowX: 'hidden'
        };

        let componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = fontSizeListStyle.width;
        componentProperties.height = fontSizeListStyle.height;
        componentProperties.scrollHeight = dataProvider != undefined ? dataProvider.length * buttonHeight : 0;
        componentProperties.top = 0;
        componentProperties.displayState = 'block';
        componentProperties.elements = elements;

        return (
            <div id='fontSizeMenu' style={menuStyle}>
                <button ref="leftButton" aria-label={hoverManager.getText('minus')} style={leftStyle} onMouseOver={this.onMouseInLeft} onMouseOut={this.onMouseOutLeft} onTouchEnd={this.onLeftClick} onClick={this.onLeftClick} onFocus={this.onFocusHandler}>
                    <span style={minusStyle}>
                        -
                    </span>
                </button>

                <div style={middleStyle} onMouseOver={this.onMouseInCenter} onMouseOut={this.onMouseOutCenter} onTouchEnd={this.onExpand} onClick={this.onExpand}>
                    <input ref='fontSizeInput' id='fontSizeMiddle' type='button' style={fontSizeStyle} aria-label={fontSizeInputAriaLabel} defaultValue={currentFontSize} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off'/>
                </div>

                <button ref="rightButton" aria-label={hoverManager.getText('plus')} style={rightStyle} onMouseOver={this.onMouseInRight} onMouseOut={this.onMouseOutRight} onTouchEnd={this.onRightClick} onClick={this.onRightClick}>
                    <span style={plusStyle}>
                        +
                    </span>
                </button>

                <div style={fontSizeListStyle} onTouchEnd={this.onListChanged} onClick={this.onListChanged}>
                    <ScrollableComponent componentProperties={componentProperties}/>
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const fontSizeListIsExpanded = state.menu.fontSizeListIsExpanded;

    return {
        fontSizeListIsExpanded
    };
}

export const FontSizeView = connect(mapStateToProps)(FontSizeViewContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/subcomponents/FontSizeView.js
 **/